<div class="wrapper">
    <div class="sidebar" data-color="azure" data-image="">
        <app-sidebar></app-sidebar>
        <div class="sidebar-background" style="background-image: url(/assets/img/sidebar-0.jpg)"></div>
    </div>

    <div class="main-panel">
        <div class="main-content">
            <!--<div class="header">
                <h1 class="h3 mb-0 text-gray-800"></h1>
            </div>-->

            <div class="myContainer">
                <div class="customContent">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="container-fluid text-center">
                                <img src="../assets/img/timeoutIcon.png" alt="Timeout Icon" height="100" width="100" />
                                <h4>You have been logged out due to inactivity.</h4>
                                <h4 style="margin-top: -15px;">Click <a [routerLink]="['/login']">here</a> to log back into the ELI Assessment Manager</h4>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <br />
            <br />
        </div>
    </div>
</div>